"use client";

import { Book, Chat, Search } from "@carbon/react/icons";
import { useRouter } from "next/navigation";
import { useState } from "react";

const ACTIONS = [
  { id: "search", href: "/search", label: "Поиск", Icon: Search },
  { id: "chat", href: "/chat", label: "Чат", Icon: Chat },
  { id: "wiki", href: "/wiki", label: "Wiki", Icon: Book },
] as const;

export function HomeAskForm() {
  const router = useRouter();
  const [query, setQuery] = useState("");

  function go(href: string) {
    const q = query.trim();
    router.push(q ? `${href}?q=${encodeURIComponent(q)}` : href);
  }

  return (
    <div className="home-ask">
      <label htmlFor="home-q" className="sr-only">
        Спросить о документах организации
      </label>
      <div className="chat-composer home-ask-composer">
        <textarea
          id="home-q"
          className="chat-composer-input"
          rows={2}
          value={query}
          placeholder="Задайте вопрос…"
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault();
              go("/chat");
            }
          }}
        />
        <div className="chat-composer-bar chat-composer-bar-end">
          <div
            className="home-ask-actions"
            role="group"
            aria-label="Куда отправить"
          >
            {ACTIONS.map(({ id, href, label, Icon }) => (
              <button
                key={id}
                type="button"
                className="chat-composer-icon"
                aria-label={label}
                onClick={() => go(href)}
              >
                <Icon size={18} />
                <span className="chat-composer-tip">
                  {label}
                  {id === "chat" ? (
                    <kbd className="chat-composer-kbd">Enter</kbd>
                  ) : null}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
